import * as React from "react";
import {connect} from "react-redux";
import MyProfileComponent from "../components/MyProfileComponent";
import {currentUserIdSelector, loadingUserSelector, userIDSelector} from "../selectors";
import {initFollow, fetchUserFollowers, fetchUserFollowing} from "../middlewares";
import {push} from "react-router-redux";
import {UsersRoutes} from "../../routes";
import {userByIdSelector} from "../../_data/selectors";

const mapStateToProps = (state, ownProps) => {
    const user = userByIdSelector(state, userIDSelector(state));
    const currentUser = userByIdSelector(state, currentUserIdSelector(state));
    const profile = user && currentUser && currentUser.id == user.id ? currentUser : user;
    return {
        profile: profile,
        currentUser: currentUser,
        loadingUser: loadingUserSelector(state),
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        viewFollowing: (id: number, name: string) => {
            dispatch(initFollow());
            dispatch(fetchUserFollowing(id, 1));

            if (window.location.toString().includes(name)) {
                dispatch(push(UsersRoutes.following(name), {refresh: false}));
            }
            else {
                dispatch(push(UsersRoutes.following(id), {refresh: false}));
            }
        },
        viewFollowers: (id: number, name: string) => {
            dispatch(initFollow());
            dispatch(fetchUserFollowers(id, 1));

            if (window.location.toString().includes(name)) {
                dispatch(push(UsersRoutes.followers(name), {refresh: false}));
            }
            else {
                dispatch(push(UsersRoutes.followers(id), {refresh: false}));
            }
        }
    }
};

const MyProfileContainer = connect(mapStateToProps, mapDispatchToProps)(MyProfileComponent);
export default MyProfileContainer;


// WEBPACK FOOTER //
// ./app/client/user/container/MyProfileContainer.tsx